import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../hooks/modalContext';
import { useAuth } from '../../../../auth/Auth';
import { cancelSubscription } from '../../../../auth/_requests';
import { showToast } from '../../../utils/showToast';
import { useState } from 'react';
import { ButtonSpinner } from '../../../UI/ButtonSpinner/ButtonSpinner';

const CancelSubscription = () => {
  const navigate = useNavigate();
  const { modalState, setModal } = useModal();
  const { auth } = useAuth();
  const { tenantMitSubscriptionId, redirectToPayRent, tenantBuildingId } = modalState || {};
  const [cancelling, setCancelling] = useState(false);
  const cancelMitSubscription = async () => {
    try {
      setCancelling(true);
      await cancelSubscription(auth?.data?.token, tenantMitSubscriptionId);
      setCancelling(false);
      showToast({
        message: 'Autopay disabled successfully',
        type: 'success',
      });
      if (redirectToPayRent && tenantBuildingId) {
        setModal(null);
        navigate('/pay-rent', {
          replace: true,
          state: {
            buildingId: tenantBuildingId,
            initialStep: 1,
            payPlan: 'direct',
            syncPayFlowFromState: true,
          },
        });
      } else if (tenantBuildingId) {
        // Return to My Homes (rather than closing every modal) so the panel
        // re-fetches this building's details and reflects autopay being off.
        setModal('my-homes', { tenantBuildingId, refreshProperties: true });
      } else {
        setModal(null);
      }
    } catch (error) {
      setCancelling(false);
      console.error('Error disabling Autopay', error);
      const message = error instanceof Error ? error.message : 'Failed to disable Autopay. Please try again.';
      showToast({
        message,
        type: 'error',
      });
      const isEquifaxBlock =
        error instanceof Error &&
        (error.message.includes('Credit Builder') || error.message.includes('Equifax'));
      if (!isEquifaxBlock) {
        setModal(null);
      }
    }
  };

  return (
    <motion.div
      className='relative w-[353px] max-h-[318px] bg-[#FFF] rounded-[12px] flex flex-col overflow-auto px-10 py-10 justify-center items-center'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <AlertTriangle className='text-[#B70D0D]' />

      <span className='text-main text-base text-center mt-2 mb-6'>
        Are you sure you want to disable autopay for this building?
      </span>
      <div className='flex justify-between w-full gap-5 p-5'>
        <button
          className='cancelBtn w-full'
          onClick={() => {
            setModal(null);
          }}
        >
          Cancel
        </button>
        <button
          className='submitBtn w-full'
          onClick={() => {
            cancelMitSubscription();
          }}
        >
          {cancelling && <ButtonSpinner />}
          Confirm
        </button>
      </div>
    </motion.div>
  );
};

export { CancelSubscription };
